import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ApexOptions } from 'apexcharts';

@Injectable({
    providedIn: 'root'
})
export class TotalProductionService {

    private isBrowser: boolean;
    private chart: any | null = null; // ApexCharts instance

    constructor(@Inject(PLATFORM_ID) private platformId: any) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    async loadChart(): Promise<void> {
        if (!this.isBrowser) return;

        try {
            const ApexCharts = (await import('apexcharts')).default;

            const chartElement = document.querySelector(
                '#crm_active_users_chart'
            ) as HTMLElement | null;

            if (!chartElement) {
                console.warn('TotalProductionService: element #crm_active_users_chart not found');
                return;
            }

            if (this.chart) {
                this.chart.destroy();
                this.chart = null;
            }

            const options : ApexOptions = {
                series: [
                    {
                        name: 'Total Production',
                        data: [2300, 2000, 2122, 1988]
                    }
                ],
                chart: {
                    type: 'area',
                    height: 100,
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: false
                    }
                },
                colors: ['#0f79f1'],
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth',
                    width: 2
                },
                labels: [
                    '10 Mar 2024',
                    '11 Mar 2024',
                    '12 Mar 2024',
                    '13 Mar 2024'
                ],
                xaxis: {
                    type: 'datetime',
                    axisBorder: {
                        show: false,
                        color: '#e0e0e0'
                    },
                    axisTicks: {
                        show: false,
                        color: '#e0e0e0'
                    },
                    labels: {
                        show: false,
                        style: {
                            colors: '#919aa3',
                            fontSize: '14px'
                        }
                    },
                    tooltip: {
                        enabled: false
                    }
                },
                yaxis: {
                    labels: {
                        show: false,
                        style: {
                            colors: '#919aa3',
                            fontSize: '14px'
                        }
                    }
                },
                legend: {
                    show: false
                },
                grid: {
                    show: false,
                    strokeDashArray: 5,
                    borderColor: '#e0e0e0'
                }
            };

            this.chart = new ApexCharts(chartElement, options);
            this.chart.render();

        } catch (error) {
            console.error('Error loading ApexCharts (TotalProduction):', error);
        }
    }

    destroyChart(): void {
        if (this.chart) {
            this.chart.destroy();
            this.chart = null;
        }
    }
}
